import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { Observable } from 'rxjs';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import * as _ from 'lodash';
import { UserRoleService } from '../../services/user-role.service';
@Component({
  selector: 'app-pde-policy',
  templateUrl: './pde-policy.component.html',
  styleUrls: ['./pde-policy.component.scss']
})
export class PdePolicyComponent implements OnInit {


  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;
  pdeForm: any
  jobData
  learnerData
  learnerName
  sign1: boolean;
  sign2: boolean;
  sign3: boolean;
  sign4: boolean;
  pdeEdit
  loading = false
  isEdit: boolean = false
  currentUser: any;
  user: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
    public _userRoleService : UserRoleService
  ) { }

  ngOnInit() {
    if(!this.isEdit)
      this.createForm()
    this.user = JSON.parse(localStorage.getItem('userRoles'))
  }




  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes of job and learner data", changes);
    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue[0]
      this.getUserRole();
      // this.instructorsList = this.jobData.instructors
      console.log("instructorsList ====== instructorsList", this.jobData);

    }

    if (changes.singleLearner && changes.singleLearner.currentValue && changes.singleLearner.currentValue != undefined) {
      this.learnerData = changes.singleLearner.currentValue
      this.learnerName = this.learnerData.name
    }

    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      this.pdeEdit = changes.assessmentEdit.currentValue
      console.log("edit form value", this.pdeEdit);
      let size = Object.keys(this.pdeEdit).length;
      console.log("what is the size of object", size);

      if (size != 0) {


        if (this.pdeEdit && this.pdeEdit.pdeForm) {
          if (this.pdeEdit.pdeForm && this.pdeEdit.pdeForm.sign1 != "") {
            this.sign1 = true
          }
          if (this.pdeEdit.pdeForm && this.pdeEdit.pdeForm.sign2 != "") {
            this.sign2 = true
          }
          if (this.pdeEdit.pdeForm && this.pdeEdit.pdeForm.sign3 != "") {
            this.sign3 = true
          }
          if (this.pdeEdit.pdeForm && this.pdeEdit.pdeForm.sign4 != "") {
            this.sign4 = true
          }
        }
        // this.selectedTrainer = this.specimanEdit.specimanForm.trainer
        this.isEdit = true
        this.createForm(this.pdeEdit)
      }
    }

  }
  getUserRole(){
    let getRole = this._userRoleService.getUserRole(this.jobData.instructors,'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if(getRole.isLearner) this.isLearner = true
    else if(getRole.isTrainer) this.isTrainer = true
    else if(getRole.isIQA) this.isIQA = true

  }

  // Form Group



  createForm(details?) {


    this.pdeForm = new FormGroup({
      leanerName: new FormControl((details && details.pdeForm) ? details.pdeForm.leanerName : this.learnerName),
      centerName: new FormControl((details && details.pdeForm) ? details.pdeForm.centerName : ''),
      ev1: new FormControl((details && details.pdeForm) ? details.pdeForm.ev1 : ''),
      ev2: new FormControl((details && details.pdeForm) ? details.pdeForm.ev2 : ''),
      ev3: new FormControl((details && details.pdeForm) ? details.pdeForm.ev3 : ''),
      ev4: new FormControl((details && details.pdeForm) ? details.pdeForm.ev4 : ''),
      ev5: new FormControl((details && details.pdeForm) ? details.pdeForm.ev5 : ''),
      ev6: new FormControl((details && details.pdeForm) ? details.pdeForm.ev6 : ''),
      ev7: new FormControl((details && details.pdeForm) ? details.pdeForm.ev7 : ''),
      ev8: new FormControl((details && details.pdeForm) ? details.pdeForm.ev8 : ''),
      ev9: new FormControl((details && details.pdeForm) ? details.pdeForm.ev9 : ''),
      leanerName1: new FormControl((details && details.pdeForm) ? details.pdeForm.leanerName1 : this.learnerName),
      sign1: new FormControl((details && details.pdeForm) ? details.pdeForm.sign1 : ''),
      assesorName: new FormControl((details && details.pdeForm) ? details.pdeForm.assesorName : ''),
      sign2: new FormControl((details && details.pdeForm) ? details.pdeForm.sign2 : ''),
      iqaName: new FormControl((details && details.pdeForm) ? details.pdeForm.iqaName : ''),
      sign3: new FormControl((details && details.pdeForm) ? details.pdeForm.sign3 : ''),
      eqaName: new FormControl((details && details.pdeForm) ? details.pdeForm.eqaName : ''),
      sign4: new FormControl((details && details.pdeForm) ? details.pdeForm.sign4 : ''),
    })

  }



  // UTILITY

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }


  addSignature(fomrControl) {

    if ((this.isTrainer || this.isIQA) && (fomrControl == 'sign1')) {
    }
    else if ((this.isLearner || this.isIQA) && (fomrControl == 'sign2')) {
      // this.exerciseReferral.get('learnerSign').disable()
    }
    else if ((this.isLearner || this.isTrainer) && (fomrControl == 'sign3')) {
      // this.exerciseReferral.get('assesorSign4').disable()
    } 
    else if (this.isLearner && (fomrControl === 'sign4')) {

    }
    else {
      this.openDialog(SignaturePadComponent).subscribe((data) => {
        console.log("data of sign", data);
        if (data == undefined) return

        let sign = data

        // if (formType == 'trackMaintenance') {
        if (fomrControl == 'sign1') {
          this.sign1 = true
          this.pdeForm.patchValue({
            sign1: sign
          })
        }
        if (fomrControl == 'sign2') {
          this.sign2 = true
          this.pdeForm.patchValue({
            sign2: sign
          })
        }
        // } else if (formType == 'techCert') {
        if (fomrControl == 'sign3') {
          this.sign3 = true
          this.pdeForm.patchValue({
            sign3: sign
          })
        }
        if (fomrControl == 'sign4') {
          this.sign4 = true
          this.pdeForm.patchValue({
            sign4: sign
          })
        }
        // }
      })
    }
  }



  // API CALL



  submitPolicy() {
    console.log("this is the final form to be send", this.pdeForm.value);
    this.loading = true

    let data = {
      learnerId: this.learnerData._id,
      jobId: this.jobData._id,
      version: true,
      details: {
        pdeForm: this.pdeForm.value,
      }
    }
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })

  }



}
